export default [
  {
    path: 'dns',
    name: 'website.dns',
    component: () => import('@/views/website/DNSManager'),
  },
];
